import angular from 'angular'
import template from './template.html'

angular.module('nominas.informacionfiscal')
  .component('nominasInformacionfiscalEmpresasEmpresaConfig', {
    require: {
      parent: '^nominasInformacionfiscalEmpresasEmpresa',
    },
    template: template,
    controller: Component,
  });

function Component(NominasInformacionfiscal) {
  let $ctrl = this;

  $ctrl.$onInit = $onInit;
  $ctrl.cancelar = cancelar;
  $ctrl.descargar = descargar;
  $ctrl.validar = validar;

  function $onInit() {
    $ctrl.descargando = false;
    $ctrl.id_proyecto = $ctrl.parent.empresa.ID_Empresa;
    $ctrl.periodo = $ctrl.parent.periodo;
    $ctrl.ejercicio = $ctrl.parent.ejercicio;
    $ctrl.descargando = true;
    NominasInformacionfiscal.get($ctrl.id_proyecto, $ctrl.ejercicio, $ctrl.periodo)
      .then(function (response) {
        $ctrl.data = response.data;
        $ctrl.opciones = {
          acuse_recibo: true,
          colaborador_cfdi_xml: true,
          colaborador_cfdi_pdf: true,
          pago_sar: $ctrl.data.pago_sar !== null,
          pago_isr: $ctrl.data.pago_isr !== null,
        };

        $ctrl.descargable = $ctrl.data.nominas.length
          || $ctrl.data.pago_isr
          || $ctrl.data.pago_sar;

        validar();
      })
      .finally(function () {
        $ctrl.descargando = false;
      });
  }

  function cancelar() {
    $ctrl.parent.onClose();
  }

  function descargar() {
    let archivo = [];

    if ($ctrl.opciones.pago_sar)
      archivo.push({
        filename: 'Recibo de pago SAR.pdf',
        url: '/kendu/proyectos/proyecto/documentos/recibo_pago_sar',
        params: {
          id_proyecto: $ctrl.id_proyecto,
          ejercicio: $ctrl.ejercicio,
          periodo: $ctrl.periodo,
          name: $ctrl.data.pago_sar,
        },
      });

    if ($ctrl.opciones.pago_isr)
      archivo.push({
        filename: 'Recibo de pago ISR.pdf',
        url: '/kendu/proyectos/proyecto/documentos/recibo_pago_isr',
        params: {
          id_proyecto: $ctrl.id_proyecto,
          ejercicio: $ctrl.ejercicio,
          periodo: $ctrl.periodo,
          name: $ctrl.data.pago_isr,
        },
      });

    $ctrl.data.nominas.forEach(function (nomina) {
      let nomina_folder = nomina.fecha + ' ' + nomina.id_nomina;

      if ($ctrl.opciones.acuse_recibo && nomina.acuse_recibo)
        archivo.push({
          filename: nomina_folder + '/' + nomina_folder + ' - Acuse de recibo.pdf',
          url: '/api/nominas/nomina/documentos/acuserecibo',
          params: {
            idEmpresa: $ctrl.id_proyecto,
            idNomina: nomina.id_nomina,
            name: nomina.acuse_recibo,
          },
        });

      if ($ctrl.opciones.acuse_recibo || $ctrl.opciones.colaborador_cfdi_xml || $ctrl.opciones.colaborador_cfdi_pdf)
        nomina.colaboradores.forEach(function (colaborador) {
          let colaborador_file = nomina_folder + ' - ' + colaborador.nombre;

          if ($ctrl.opciones.colaborador_cfdi_xml)
            archivo.push({
              filename: nomina_folder + '/' + colaborador.nombre + '/' + colaborador_file + ' - CFDI.xml',
              url: '/api/nominas/nomina/colaboradores/colaborador/documentos/cfdi',
              params: {
                id_proyecto: $ctrl.id_proyecto,
                id_nomina: nomina.id_nomina,
                id_colaborador: colaborador.id_colaborador,
                formato: 'xml',
              },
            });

          if ($ctrl.opciones.colaborador_cfdi_pdf)
            archivo.push({
              filename: nomina_folder + '/' + colaborador.nombre + '/' + colaborador_file + ' - CFDI.pdf',
              url: '/api/nominas/nomina/colaboradores/colaborador/documentos/cfdi',
              params: {
                id_proyecto: $ctrl.id_proyecto,
                id_nomina: nomina.id_nomina,
                id_colaborador: colaborador.id_colaborador,
                formato: 'pdf',
              },
            });
        });
    });

    $ctrl.parent.descargar(archivo);
  }

  function validar() {
    $ctrl.valido = $ctrl.opciones.acuse_recibo
      || $ctrl.opciones.colaborador_cfdi_xml
      || $ctrl.opciones.colaborador_cfdi_pdf
      || $ctrl.opciones.pago_sar
      || $ctrl.opciones.pago_isr;
  }
}



// WEBPACK FOOTER //
// ./src/nominas/informacionfiscal/components/empresas/empresa/config/component.js